import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./screens/Home";

function App() {
  return (
    <Router>
      <Routes>
        {/* Any path shows the form: /repsol-881 carries an ad code. */}
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
